import { Button, Stack, Typography } from '@mui/material';
import { Page } from '@tap/mui-ui';
import { Link, useNavigate } from 'react-router';
import { useSession } from '../auth';
/*
*   Страница Ошибки
*/

export enum ButtonVariant {
    Hide = 'hide',
    HomeLink = 'home',
    Back = 'back',
    SignOut = 'signOut',
}

type ErrorPageProps = {
    code?: number | string,
    errorText?: string,
    buttonVariant?: ButtonVariant,
}


export function ErrorPage({
    code = '500',
    errorText = 'Ошибка',
    buttonVariant = ButtonVariant.HomeLink,
}: ErrorPageProps) {
    const navigate = useNavigate();

    const { signOut } = useSession();

    return (
        <Page.Root>
            <Stack
                direction='column'
                alignItems='center'
                justifyContent='center'
                spacing={2}
                sx={{ minHeight: '75vh' }}
            >
                <Typography variant='h1'>{code}</Typography>

                <Typography variant='h6' component='p'>{errorText}</Typography>

                {buttonVariant === ButtonVariant.HomeLink && (
                    <Button
                        variant='contained'
                        size='large'
                        component={Link}
                        to='/'
                    >
                        На главную
                    </Button>

                )}

                {buttonVariant === ButtonVariant.SignOut && (
                    <Button
                        variant='contained'
                        size='large'
                        onClick={() => signOut()}
                    >
                        Выйти
                    </Button>
                )}

                {buttonVariant === ButtonVariant.Back && (
                    <Button
                        variant='contained'
                        size='large'
                        onClick={() => window.history.back()}
                    >
                        Назад
                    </Button>
                )}

            </Stack>

        </Page.Root>
    );
}
